import { useState } from 'react';
import './workContractModification.scss';
import PlainNavBar from './navbar/navBar';
import InputBox, { DropDown } from 'components/inputBox/inputBox';
import DropDownWithInput from '../../components/dropdownWithInput/dropdownWithInput';
import HolidaySelection from './holidaySelection/holidaySelection';
import { GreenCheckBox } from '../../components/greenCheckboxes/greenCheckBox';
const WorkContractModification = () => {
  const [holiday, setHoliday] = useState<string>('적용안함');
  return (
    <>
      <PlainNavBar />
      <div className="workContractModification">
        <div className="container">
          <div className="breadCrumb">
            <div className="mainScreen">직원목록</div> {'>'}
            <div className="secondScreen">근무일정</div>
          </div>

          <div className="nameContainer">
            <div className="image">길동</div>
            <div className="nameText">홍길동</div>
          </div>

          <div className="card">
            <div className="leftContainer">
              <div className="header">템플릿 정보 </div>
              <InputBox value={'템플릿명 입력 '} label="템플릿명*" />

              <DropDownWithInput label="급여정보*" options={['시급', 'ff']} placeHolder="금액 입력" />

              <HolidaySelection
                primaryLabel={'(+) 주휴수당 자동 가산'}
                secondaryLabel={'(자동)근로기준법 기준'}
                ternaryLabel={'(수동)월 근무시간'}
                ternaryUnits={'시간'}
              />
              <HolidaySelection
                primaryLabel={'(-) 휴게시간 자동 차감'}
                secondaryLabel={'(자동)근로기준법 기준'}
                ternaryLabel={'(수동)월 휴계시간'}
                ternaryUnits={'분'}
              />
              <HolidaySelection primaryLabel={'(+) 추가, 야간, 휴일수당 50% 자동 가산'} />

              <div className="incomeDeclaration">
                <DropDown
                  label="소득신고"
                  options={['적용안함', '4대보험']}
                  onSelect={(data: string) => {
                    setHoliday(data);
                  }}
                />

                <div className="checkboxRow" style={{ opacity: holiday === '4대보험' ? 100 : 0 }}>
                  <div className="checkBoxWrapper">
                    <GreenCheckBox onCheck={(check: boolean) => {}} defaultValue={false} text={'국민연금'} />
                  </div>
                  <div className="checkBoxWrapper">
                    <GreenCheckBox onCheck={(check: boolean) => {}} defaultValue={false} text={'건강보험'} />
                  </div>
                  <div className="checkBoxWrapper">
                    <GreenCheckBox onCheck={(check: boolean) => {}} defaultValue={false} text={'고용보험'} />
                  </div>
                  <div className="checkBoxWrapper">
                    <GreenCheckBox onCheck={(check: boolean) => {}} defaultValue={false} text={'산재보험'} />
                  </div>
                </div>
              </div>
            </div>
            <div className="rightContainer">
              <div className="titleText">적용 시작월</div>
              <div className="description">시작월 부터 자동으로 급여가 계산됩니다.</div>
              <div className="titleText second">근로 템플릿이란?</div>
              <div className="description">직원들의 급여 정보를 템플릿으로 저장해두고 한번에 적용시킬 수 있어요</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WorkContractModification;
